'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PickerBlock_module = require('./PickerBlock.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const PickerBlockItem = _ref => {
  let {
    value,
    label,
    onChange
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement("button", {
    className: PickerBlock_module["default"].pickerBlockItem,
    key: value,
    value: value,
    onClick: () => onChange === null || onChange === void 0 ? void 0 : onChange(value)
  }, label);
};
const PickerBlock = _ref2 => {
  let {
    items,
    onChange
  } = _ref2;
  const [active, setActive] = React.useState(null);
  const handleChange = key => {
    setActive(key);
    onChange === null || onChange === void 0 ? void 0 : onChange(key);
  };
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: PickerBlock_module["default"].pickerBlock
  }, items.map(_ref3 => {
    let {
      value,
      label
    } = _ref3;
    return /*#__PURE__*/React__default["default"].createElement(PickerBlockItem, {
      value: value,
      label: label,
      onChange: () => {
        handleChange(value);
      },
      key: value,
      active: active === value
    });
  }));
};

exports.PickerBlock = PickerBlock;
